<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <Reports />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
};
</script>